import { useState, useEffect } from 'react';
import { Box, FormControl, Stack, FormLabel, Text } from '@chakra-ui/react';
import { Field } from 'formik';
import DropDown from '../../../../components/forms/new/formikFormFields/DropDown';
import TriggerFieldToolTip from './formFields/TriggerFieldToolTip';
import { useTriggerForm } from './useTriggerForm.js';
import walkthroughIds from '../walkthroughIds';
import { FORM_FIELD_PATHS } from './triggerFormConstants.js';
import { addSpacing } from 'utils/utils';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const TriggerEventSection = ({
    darkMode,
    eventEnum,
    isEventsLoading,
    onEventChange,
    errors,
    touched,
}) => {
    const { editMode } = walkthroughIds;
    const [isHovered, setIsHovered] = useState(false);

    const { formData, updateFormData } = useTriggerForm();

    useEffect(() => {
        updateFormData(FORM_FIELD_PATHS.EVENT_ID, formData?.eventID);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!formData?.triggerType) return null;

    const handleSelectChange = (item) => {
        const eventID = item?.id;
        updateFormData(FORM_FIELD_PATHS.EVENT_ID, eventID);
        updateFormData(FORM_FIELD_PATHS.EVENT, item);
        if (onEventChange) {
            onEventChange(eventID);
        }
    };

    const filteredEventEnum =
        eventEnum?.filter(({ requiredScope: requiredScopeMenu }) => {
            switch (formData?.triggerType) {
                case 'Company':
                    return requiredScopeMenu <= 20;
                case 'Partner':
                    return requiredScopeMenu <= 40;
                case 'Wholesaler':
                    return requiredScopeMenu <= 60;
                default:
                    return true;
            }
        }) || [];

    return (
        <Box margin="20px 0px">
            <FormControl
                sx={{ margin: '0 !important', position: 'relative' }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                isInvalid={!!errors?.eventID && touched?.eventID}>
                <Stack
                    direction="row"
                    spacing={stackSpacing}
                    sx={stackStyling(true)}>
                    <Box>
                        <FormLabel sx={formLabelStyling(darkMode)}>
                            Event <span style={{ color: '#e53e3e' }}>*</span>
                        </FormLabel>
                        <Text sx={descriptionStyling} maxWidth={250}>
                            Select the event that will trigger this automation.
                        </Text>
                    </Box>
                    <Box flex={1} maxWidth="400px">
                        <Field
                            component={DropDown}
                            id="eventID"
                            name="eventID"
                            data={filteredEventEnum}
                            shownValue={(item) =>
                                `${addSpacing(item.name)} - ${item.description}`
                            }
                            currentId={formData?.eventID}
                            selectedId="id"
                            placeholder="Select Event"
                            handleSelectChange={handleSelectChange}
                            width="100%"
                            isLoading={isEventsLoading}
                            darkMode={darkMode}
                            walkthroughId={editMode.ufEventSelect}
                            validate={(value) => {
                                if (!value) {
                                    return 'Please select an event';
                                }
                            }}
                        />
                    </Box>
                    <TriggerFieldToolTip
                        isVisible={isHovered}
                        label="Select the specific event that will trigger this automation"
                        ariaLabel="trigger-event-tip"
                    />
                </Stack>
            </FormControl>
        </Box>
    );
};

export default TriggerEventSection;
